module.exports = __webpack_public_path__ + "img/Asset1.63469f75.png";